import { render, staticRenderFns } from "./SubSectionText.vue?vue&type=template&id=218f49b4&scoped=true"
import script from "./SubSectionText.vue?vue&type=script&lang=js"
export * from "./SubSectionText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f49b4",
  null
  
)

export default component.exports